import { render, staticRenderFns } from "./CreateReservationView.vue?vue&type=template&id=0fde6c10"
import script from "./CreateReservationView.vue?vue&type=script&lang=js"
export * from "./CreateReservationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports